export default __webpack_public_path__ + "static/media/9_16-clip-ad-web.9521e088.png";